// extracted by mini-css-extract-plugin
export default {"root":"InventoryModal_root__9T7Xv","container":"InventoryModal_container__7Yp-V"};